<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <h2 class="text-h5">Пользователи системы</h2>
      <v-btn
        color="primary"
        :disabled="selectedUsers.length === 0"
        @click="handleAssignClick"
      >
        Назначить роль
      </v-btn>
    </div>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="users"
      :loading="loading"
      item-key="id"
      show-select
      class="elevation-1"
    >
      <template #item.is_superuser="{ item }">
        <v-chip
          :color="item.is_superuser ? 'error' : 'default'"
          small
          text-color="white"
        >
          {{ item.is_superuser ? 'Администратор' : 'Пользователь' }}
        </v-chip>
      </template>
      <template #item.fullName="{ item }">
        <span :class="{ 'font-weight-bold error--text': item.is_superuser }">
          {{ getFullName(item) }}
        </span>
      </template>
      <template #item.email="{ item }">
        <span :class="{ 'font-weight-bold error--text': item.is_superuser }">
          {{ item.email }}
        </span>
      </template>
      <template #item.permissions="{ item }">
        <v-chip
          v-for="perm in item.permissions"
          :key="perm"
          small
          class="mr-1 mb-1"
        >
          {{ perm }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'UsersTable',
  props: {
    users: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: [],
      headers: [
        { text: 'ФИО', value: 'fullName', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Статус', value: 'is_superuser', sortable: true },
        { text: 'Права доступа', value: 'permissions', sortable: false }
      ]
    }
  },
  computed: {
    selectedUsers() {
      return this.selected.filter(user => !user.is_superuser)
    }
  },
  methods: {
    getFullName(user) {
      const parts = [user.surname, user.name, user.patronymic].filter(Boolean)
      return parts.join(' ') || user.email
    },
    handleAssignClick() {
      const userIds = this.selectedUsers.map(user => user.id)
      if (userIds.length === 0) {
        this.$store.dispatch('common/actionAddErrorMessage', 'Выберите пользователей')
        return
      }
      this.$emit('assign-permission', userIds)
    }
  }
}
</script>

<style scoped>
::v-deep .v-data-table__wrapper tbody tr.error--text {
  background-color: rgba(244, 67, 54, 0.1) !important;
}
</style>
